// ============================================================================
// useClickOutside.ts
// Reusable hook for handling click outside
// ============================================================================

import { useEffect, RefObject } from "react";

export const useClickOutside = (
  refs: RefObject<HTMLElement>[],
  handler: () => void,
  enabled: boolean,
) => {
  useEffect(() => {
    if (!enabled) return;

    const handleClickOutside = (event: MouseEvent) => {
      const clickedOutside = refs.every(
        (ref) => ref.current && !ref.current.contains(event.target as Node),
      );

      if (clickedOutside) {
        handler();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [refs, handler, enabled]);
};
